import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d099d8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "font-montserrat-bold font-15" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Montar Carrinho de Compras ")
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text_label" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/lista_de_compras.svg"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Listas de Compras ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ion-text-start" }, [
  /*#__PURE__*/_createTextVNode(" Você ainda não possui "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("nenhuma lista de compras salva. "),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Para criar uma, siga os seguintes passos:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-montserrat-bold font-25 layout_blue" }, " 1 "),
  /*#__PURE__*/_createTextVNode(" Adicione os produtos ao seu carrinho de compras")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-montserrat-bold font-25 layout_blue" }, " 2 "),
  /*#__PURE__*/_createTextVNode(" Entre na tela do carrinho")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-montserrat-bold font-25 layout_blue" }, " 3 "),
  /*#__PURE__*/_createTextVNode(" Clique em Salvar ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-montserrat-bold font-25 layout_blue" }, " 4 "),
  /*#__PURE__*/_createTextVNode(" Crie um nome para sua lista")
], -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = {
  key: 1,
  class: "font-montserrat-bold"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, { "is-open": _ctx.isOpenRef }, {
        default: _withCtx(() => [
          _createVNode(_component_SafeArea, {
            onOnBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenRef=false)),
            data: {'cart': false}
          }),
          _createVNode(_component_ion_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "ion-text-center font-montserrat layout_blue font-25"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.minhaslistas.selecionado.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.minhaslistas.selecionado.items.length) + " Items", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toSugetion())),
                        color: "jauservelayoutalter",
                        shape: "jau",
                        expand: "block",
                        size: "medium"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: _ctx.iconAvancar
                          }, null, 8, ["icon"]),
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minhaslistas.selecionado.items, (product, index_prod) => {
                    return (_openBlock(), _createBlock(_component_ion_item, { key: index_prod }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_avatar, { slot: "start" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _ctx.getImage(product)
                            }, null, 8, _hoisted_3)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(product.info[0].name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _hoisted_6,
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[2] || (_cache[2] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat layout_blue font-25"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              (_ctx.minhaslistas.listas.length==0)
                ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-align-items-center font-montserrat" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "12" }, {
                            default: _withCtx(() => [
                              _hoisted_10,
                              _hoisted_11,
                              _hoisted_12,
                              _hoisted_13,
                              _hoisted_14,
                              _hoisted_15,
                              _hoisted_16,
                              _hoisted_17
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minhaslistas.listas, (lista, index) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  id: "open-modal",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_note, {
                      slot: "start",
                      onClick: ($event: any) => (_ctx.showLista(lista)),
                      color: "jauservelayoutalter"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.toDia(lista.createdAt)), 1),
                        _hoisted_18,
                        _createElementVNode("span", null, _toDisplayString(_ctx.toMese(lista.createdAt)), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_ion_label, {
                      onClick: ($event: any) => (_ctx.showLista(lista))
                    }, {
                      default: _withCtx(() => [
                        (lista.loading)
                          ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                              key: 0,
                              animated: true
                            }))
                          : (_openBlock(), _createElementBlock("h2", _hoisted_19, _toDisplayString(lista.name), 1)),
                        (lista.items)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(lista.items.length + " Itens"), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (!lista.loading)
                      ? (_openBlock(), _createBlock(_component_ion_note, {
                          key: 0,
                          slot: "end",
                          color: "jauservelayoutalter"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21,
                            (!lista.remove)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.removeLista(lista)),
                                  color: "jauservelayoutalter",
                                  expand: "block",
                                  size: "small",
                                  shape: "round"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "icon-only",
                                      icon: _ctx.iconTrash
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 1,
                                  color: "jauservelayoutalter",
                                  shape: "jau",
                                  expand: "block"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_spinner, { name: "circular" })
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}